<template>
    <div>
        <Popup ref="popup" :minWidth="400" :isShowHeader="false" :isShowClose="true" :is-show="isShowPopup" @closed="closedPopup" title="Thông báo" :height="$app.isMobile ? '100%' : '80%'" :width="$app.isMobile ? '100%' : '80%'" :customCss="{'bg-white': billdetail.formOfBill == 1 || billdetail.formOfBill == 3 || billdetail.formOfBill == 4, 'bg-blue-100': billdetail.formOfBill == 2 }">
            <template slot="header">
                <div class="bg-brand p-3 md:p-4 flex items-center justify-between w-full h-full z-50 shrink-0 border-b border-brand-dark" style="background-color: var(--color-brand);">
                    <div class="text-white rounded-md font-bold flex flex-wrap gap-2 items-center">
                        <div class="flex flex-wrap gap-2"
                            v-if="(billdetail.billType === 1 && (billdetail.formOfBill === 1 || billdetail.formOfBill === 3)) || billdetail.billType === 3">
                            <button v-if="currentIndex === 0" @click="changePage(1)"
                                class="py-1.5 px-3 rounded-lg bg-white/10 border border-white/20 text-white/90 font-semibold hover:bg-white hover:text-brand transition-all text-[13px] sm:text-[14px] flex items-center gap-1.5 shadow-sm">
                                <font-awesome-icon :icon="['fas', 'table']" /><span v-if="billdetail.billType === 1 ">Xem
                                    bảng kê chi phí</span><span v-else-if="billdetail.billType === 3">Xem bảng TTU</span>
                            </button>
                            <button v-else @click="changePage(0)"
                                class="py-1.5 px-3 rounded-lg bg-white/10 border border-white/20 text-white/90 font-semibold hover:bg-white hover:text-brand transition-all text-[13px] sm:text-[14px] flex items-center gap-1.5 shadow-sm">
                                <font-awesome-icon :icon="['fas', 'backward']" /> Trở về trang phiếu
                            </button>
                            <button v-if="(billdetail.formOfBill === 1 || billdetail.formOfBill === 3) && billdetail.billType === 1"
                                class="py-1.5 px-3 rounded-lg bg-white/10 border border-white/20 text-white/90 font-semibold hover:bg-white hover:text-brand transition-all text-[13px] sm:text-[14px] flex items-center gap-1.5 shadow-sm"
                                @click="exportExcel(billdetail.id)">
                                <font-awesome-icon :icon="['fas', 'file-excel']" /> Xuất Excel
                            </button>
                        </div>
                        <div v-else-if="billdetail.billType === 2" class="text-[16px] text-yellow-500 tracking-wide">PHIẾU ĐỀ NGHỊ TẠM ỨNG</div>
                        
                        <button class="py-1.5 px-3 rounded-lg bg-emerald-600 border border-emerald-500 text-white font-semibold hover:bg-emerald-500 transition-all text-[13px] sm:text-[14px] flex items-center gap-1.5 shadow-md hover:scale-[1.02] active:scale-[0.98] cursor-pointer"
                            @click="print()" title="In phiếu chi bằng máy in kết nối">
                            <font-awesome-icon :icon="['fas', 'print']" /> In phiếu
                        </button>
                    </div>
                    <div class="ml-4 flex-shrink-0">
                        <button @click="closedPopup()"
                            class="w-8 h-8 rounded-full bg-white/10 hover:bg-red-500 text-white/90 hover:text-white transition-colors flex items-center justify-center cursor-pointer shadow-sm">
                            <font-awesome-icon :icon="['fas', 'xmark']" />
                        </button>
                    </div>
                </div>
            </template>
            <template slot="body">
    
                <div ref="printArea">
                    <div class="sm:p-4">
                        <div class="w-full flex justify-center">
                            <img class="w-full max-w-[650px]" :src="($app.theme && $app.theme.headerBillUrl && $app.theme.headerBillUrl !== 'null' && $app.theme.headerBillUrl.trim() !== '') ? $app.theme.headerBillUrl : require('../../assets/headerBill.png')" alt="Header picture">
                        </div>
                        <div v-if="billdetail.formOfBill !== 4" class="relative w-full overflow-hidden">
                            <div class="flex transition-transform duration-500" ref="scrollWrapper"
                                :class="{ '-translate-x-full': currentIndex === 1 }">
                                <div class="w-full flex-shrink-0">
                                    <div v-if="currentIndex === 0">
                                        <div class="m-4 text-center">
                                            <h2 class="font-bold sm:text-xl text-lg">{{ headerTitle }}</h2>
                                            <i class="text-xs">Mã phiếu: <strong>{{ billdetail.code }}</strong></i><br>
                                            <i class="text-xs">{{ formatDate(billdetail.createdAt) }}</i><br>
                                            <strong class="sm:text-base text-sm" v-if="billdetail.company">Kính gửi: {{ billdetail.company }}</strong>
                                            <strong class="sm:text-base text-sm" v-else>Kính gửi: Ban Giám Đốc Công Ty TNHH HIGHLAND AGRI Việt
                                                Nam</strong>
                                        </div>
                                        <div class="sm:text-base text-sm">Họ và tên người đề nghị thanh toán:
                                            <strong>{{ billdetail.authuserslog.name }}</strong>
                                        </div>
                                        <div class="sm:text-base text-sm">
                                            <template v-if="billdetail.formOfBill !== 1 && billdetail.formOfBill !== 3">Bộ phận: </template>
                                            <template v-else>Bộ phận (Hoặc địa chỉ): </template>
                                            <strong>{{ billdetail.departments && billdetail.departments.length ? billdetail.departments[0].name : '' }}</strong>
                                        </div>
                                        <div class="sm:text-base text-sm">
                                            <span v-if="billdetail.billType !== 2">Nội dung thanh toán</span><span v-else>Nội
                                                dung tạm
                                                ứng</span>: <strong>{{
                                                    billdetail.interpretation }}</strong>
                                        </div>
                                        <div class="sm:text-base text-sm"><span v-if="billdetail.billType !== 2">Giá trị thanh
                                                toán</span><span v-else>Tổng giá trị tạm ứng</span>: {{
                                                    formatVND(Number(billdetail.expense)) }} -
                                            <span class="italic">({{ formattedAmount(billdetail.expense) }}.)</span>
                                        </div>
                                        <div class="font-bold underline italic sm:text-base text-sm">Hình thức thanh toán:</div>
                                        <div class="sm:text-base text-sm">(Áp dụng đối với việc thanh toán cho cá nhân, đơn vị
                                            cung
                                            cấp hàng
                                            hóa, dịch
                                            vụ
                                            cho HIGHLAND AGRI)</div>
                                        <div class="grid grid-cols-2 gap-2 sm:w-1/2 my-4 w-auto sm:text-base text-sm">
                                            <div class="grid grid-cols-1 gap-2">
                                                <li>Tiền mặt</li>
                                                <li>Chuyển khoản</li>
                                            </div>
                                            <div class="grid grid-cols-1 gap-2">
                                                <div>
                                                    <div v-if="billdetail.paymentMethod === '1'">
                                                        <span>✔</span>
                                                    </div>
                                                    <input v-else type="checkbox" id="checkboxoption" value="1"
                                                        :checked="billdetail.paymentMethod === '1'"
                                                        class="pointer-events-none print:appearance-auto"
                                                        style="appearance: auto;">
                                                </div>
                                                <div>
                                                    <div v-if="billdetail.paymentMethod === '2'">
                                                        <span>✔</span>
                                                    </div>
                                                    <input v-else type="checkbox" id="checkboxoption" value="2"
                                                        :checked="billdetail.paymentMethod === '2'"
                                                        class="pointer-events-none print:appearance-auto"
                                                        style="appearance: auto;">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="my-4 sm:text-base text-sm">
                                            <div v-if="billdetail.paymentMethod === '2'">
                                                <div>Tên tài khoản: <span class="italic">{{ billdetail.accountName }}</span></div>
                                                <div>Số tài khoản: <span class="italic">{{ billdetail.accountNumber }}</span>
                                                    <button v-if="billdetail.accountNumber"
                                                        @click="copyToClipboard(billdetail.accountNumber)"
                                                        class="ml-2 text-xs border-2 rounded-md px-[4px] py-[2px] bg-gray-400 text-white">Sao
                                                        chép</button>
                                                </div>
                                                <div>Ngân hàng: <span class="italic">{{ billdetail.bankName }}</span></div>
                                            </div>
                                            <div>Chi tại: <span class="italic">{{ checkformBill(billdetail.formOfBill).label
                                            }}</span></div>
                                            <div v-if="billdetail.store">Tên cửa hàng: <span class="italic font-bold">{{ billdetail.store.shortaddress
                                            }}</span>
                                            </div>
                                            <div v-if="billdetail.store">Địa chỉ: <span class="italic">{{ billdetail.store.fulladdress }}</span></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-full flex-shrink-0">
                                    <div v-if="currentIndex === 1">
                                        <div v-if="billdetail.billType === 1 && billdetail.formOfBill === 3">
                                            <div class="m-4 text-center">
                                                <h2 class="font-bold sm:text-xl text-lg">BẢNG KÊ CHI PHÍ</h2>
                                                <i class="text-xs">{{ formatDate(billdetail.createdAt) }}</i><br>
                                            </div>
                                            <div class="mt-4 mb-4 sm:text-base text-sm">
                                                <div class="overflow-x-auto">
                                                    <table class="text-center border-2 border-solid w-full">
                                                        <thead class="border-2 border-solid">
                                                            <td class="w-[50px] border-2 border-solid border-black">
                                                                STT</td>
                                                            <td class="min-w-[100px] w-full border-2 border-solid border-black">
                                                                NGÀY</td>
                                                            <td class="min-w-[200px] w-full border-2 border-solid border-black">
                                                                DIỄN GIẢI</td>
                                                            <td class="min-w-[60px] w-full border-2 border-solid border-black">
                                                                ĐVT</td>
                                                            <td class="min-w-[120px] w-full border-2 border-solid border-black">
                                                                SỐ LƯỢNG</td>
                                                            <td class="min-w-[150px] w-full border-2 border-solid border-black">
                                                                ĐƠN GIÁ</td>
                                                            <td class="min-w-[150px] w-full border-2 border-solid border-black">
                                                                SỐ TIỀN</td>
                                                            <td class="min-w-[200px] w-full border-2 border-solid border-black">
                                                                GHI CHÚ</td>
                                                        </thead>
                                                        <tbody v-if="billdetail.paymentGroup[0].detail !== ''"
                                                            class=" border-2 border-solid"
                                                            v-for="(data, index) in billdetail.paymentGroup" :key="index">
                                                            <td class=" border-2 border-solid border-black">{{ index + 1 }}</td>
                                                            <td class=" border-2 border-solid border-black">{{
                                                                formatDateSignUser(data.date)
                                                                }}</td>
                                                            <td class=" border-2 border-solid border-black">{{ data.detail }}
                                                            </td>
                                                            <td class=" border-2 border-solid border-black">{{ data.unit }}</td>
                                                            <td class=" border-2 border-solid border-black">{{ data.quantity }}
                                                            </td>
                                                            <td class=" border-2 border-solid border-black">{{
                                                                formatVND(Number(data.price))
                                                                }}</td>
                                                            <td class=" border-2 border-solid border-black">{{
                                                                formatVND(Number(data.money))
                                                                }}</td>
                                                            <td class=" border-2 border-solid border-black">{{ data.note }}</td>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else-if="billdetail.billType === 3">
                                            <div class="m-4 text-center">
                                                <h2 class="font-bold sm:text-xl text-lg">GIẤY THANH TOÁN TIỀN TẠM ỨNG</h2>
                                                <i class="text-xs">{{ formatDate(billdetail.createdAt) }}</i><br>
                                            </div>
                                            <div class="overflow-x-auto">
                                                <table class="w-full border-collapse border border-gray-300 text-sm">
                                                    <thead>
                                                        <tr class="bg-gray-100 text-left">
                                                            <th class="w-[50px] border border-gray-300 p-2">STT</th>
                                                            <th class="min-w-[200px] w-full border border-gray-300 p-2">DIỄN
                                                                GIẢI</th>
                                                            <th class="min-w-[150px] w-full border border-gray-300 p-2">SỐ TIỀN
                                                            </th>
                                                            <th class="min-w-[200px] w-full border border-gray-300 p-2">GHI CHÚ
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <!-- I. SỐ TIỀN TẠM ỨNG -->
                                                        <tr>
                                                            <td colspan="2" class="border border-gray-300 p-2 font-bold">I. SỐ
                                                                TIỀN
                                                                TẠM ỨNG:
                                                                (1)</td>
                                                            <td class="border border-gray-300 p-2">
                                                                {{ formatVND(Number(billdetail.paymentGroup.AdvanceMoney.money))
                                                                }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2">
                                                                {{ billdetail.paymentGroup.AdvanceMoney.note }}
                                                            </td>
                                                        </tr>
        
                                                        <!-- II. SỐ TIỀN ĐÃ CHI -->
                                                        <tr>
                                                            <td colspan="5" class="border border-gray-300 p-2 font-bold">
                                                                II. SỐ TIỀN ĐÃ CHI: (2)
                                                            </td>
                                                        </tr>
        
                                                        <tr v-for="(data, index) in billdetail.paymentGroup.SpentMoney"
                                                            :key="index">
                                                            <td class="border border-gray-300 p-2 text-center">{{ index + 1 }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2">
                                                                {{ data.detail }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2">
                                                                {{ formatVND(Number(data.money)) }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2">
                                                                {{ data.note }}
                                                            </td>
                                                        </tr>
        
        
                                                        <!-- III. CHÊNH LỆCH -->
                                                        <tr>
                                                            <td colspan="4" class="border border-gray-300 p-2 font-bold">III.
                                                                CHÊNH
                                                                LỆCH
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="border border-gray-300 p-2 text-center">1</td>
                                                            <td class="border border-gray-300 p-2">Số tạm ứng chi không hết (I -
                                                                II)
                                                            </td>
                                                            <td class="border border-gray-300 p-2">
                                                                {{billdetail.paymentGroup.noteRemainingAdvance === 0 ? '' :
                                                                    formatVND(heckNegative(Number(billdetail.paymentGroup.AdvanceMoney.money)
                                                                        -
                                                                        billdetail.paymentGroup.SpentMoney.reduce((total, item) => total
                                                                            +
                                                                            Number(item.money), 0)))}}
                                                            </td>
                                                            <td class="border border-gray-300 p-2">
                                                                {{ billdetail.paymentGroup.noteRemainingAdvance }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="border border-gray-300 p-2 text-center">2</td>
                                                            <td class="border border-gray-300 p-2">Chi quá số tạm ứng (II - I)
                                                            </td>
                                                            <td class="border border-gray-300 p-2">
                                                                {{billdetail.paymentGroup.noteExcessAdvance === 0 ? '' :
                                                                    formatVND(heckNegative(Number(billdetail.paymentGroup.SpentMoney.reduce((total,
                                                                        item) => total + Number(item.money), 0)) -
                                                                        Number(billdetail.paymentGroup.AdvanceMoney.money)))}}
                                                            </td>
                                                            <td class="border border-gray-300 p-2">
                                                                {{ billdetail.paymentGroup.noteExcessAdvance }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div v-if="billdetail.billType === 1 && billdetail.formOfBill === 1">
                                            <div class="m-4 text-center">
                                                <h2 class="font-bold sm:text-xl text-lg">BẢNG TỔNG HỢP CHI PHÍ</h2>
                                                <i class="text-xs">{{ formatDate(billdetail.createdAt) }}</i><br>
                                            </div>
                                            <div class="overflow-x-auto">
                                                <table class="w-full border-collapse border border-gray-300 text-sm">
                                                    <thead>
                                                        <tr class="bg-gray-100 text-left">
                                                            <th class="w-[50px] border border-gray-300 p-2">STT</th>
                                                            <th class="min-w-[100px] w-full border border-gray-300 p-2">Ngày
                                                                <span class="text-red-500">*</span>
                                                            </th>
                                                            <th class="min-w-[200px] w-full border border-gray-300 p-2">Diễn
                                                                giải<span class="text-red-500">*</span></th>
                                                            <th class="min-w-[60px] w-full border border-gray-300 p-2">ĐVT <span
                                                                    class="text-red-500">*</span></th>
                                                            <th class="min-w-[100px] w-full border border-gray-300 p-2">Số lượng
                                                                <span class="text-red-500">*</span>
                                                            </th>
                                                            <th class="min-w-[120px] w-full border border-gray-300 p-2">Đơn giá
                                                                <span class="text-red-500">*</span>
                                                            </th>
                                                            <th class="min-w-[120px] w-full border border-gray-300 p-2">Số tiền
                                                                <span class="text-red-500">*</span>
                                                            </th>
                                                            <th class="min-w-[200px] w-full border border-gray-300 p-2">Ghi chú
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td class="border border-gray-300 p-2 text-center font-bold"
                                                                colspan="6">TOTAL
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center font-bold">
                                                                {{ formatVND(Number(totalAllMoney)) }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ billdetail.paymentGroup.totalNote }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="border border-gray-300 p-2 text-center font-bold"
                                                                colspan="6">TỔNG NVL
                                                                TỒN KHO</td>
                                                            <td class="border border-gray-300 p-2 text-center font-bold">{{
                                                                formatVND(getTotalMoney(billdetail.paymentGroup.totalInventoryMaterials))
                                                                }}</td>
                                                            <td class="border border-gray-300 p-2 text-center"></td>
                                                        </tr>
                                                        <tr
                                                            v-for="(item, index) in billdetail.paymentGroup.totalInventoryMaterials">
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ index + 1 }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ formatDateSignUser(item.date) }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ item.detail }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ item.unit }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ item.quantity }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ formatVND(Number(item.price)) }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ formatVND(Number(item.money)) }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2">
                                                                {{ item.note }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="border border-gray-300 p-2 text-center font-bold"
                                                                colspan="6">TỔNG VT
                                                                LẺ</td>
                                                            <td class="border border-gray-300 p-2 text-center font-bold">{{
                                                                formatVND(getTotalMoney(billdetail.paymentGroup.totalCeremonyMaterials))
                                                                }}</td>
                                                            <td class="border border-gray-300 p-2 text-center"></td>
                                                        </tr>
                                                        <tr
                                                            v-for="(item, index) in billdetail.paymentGroup.totalCeremonyMaterials">
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ index + 1 }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ formatDateSignUser(item.date) }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ item.detail }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ item.unit }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ item.quantity }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ formatVND(Number(item.price)) }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ formatVND(Number(item.money)) }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2">
                                                                {{ item.note }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="border border-gray-300 p-2 text-center font-bold"
                                                                colspan="6">TỔNG NVL
                                                                KHÔNG TỒN KHO</td>
                                                            <td class="border border-gray-300 p-2 text-center font-bold">{{
                                                                formatVND(getTotalMoney(billdetail.paymentGroup.totalNonInventoryMaterials))
                                                                }}</td>
                                                            <td class="border border-gray-300 p-2 text-center"></td>
                                                        </tr>
                                                        <tr
                                                            v-for="(item, index) in billdetail.paymentGroup.totalNonInventoryMaterials">
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ index + 1 }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ formatDateSignUser(item.date) }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ item.detail }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ item.unit }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ item.quantity }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ formatVND(Number(item.price)) }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ formatVND(Number(item.money)) }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2">
                                                                {{ item.note }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="border border-gray-300 p-2 text-center font-bold"
                                                                colspan="6">TỔNG KHÁC
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center font-bold">{{
                                                                formatVND(getTotalMoney(billdetail.paymentGroup.totalOther)) }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center"></td>
                                                        </tr>
                                                        <tr v-for="(item, index) in billdetail.paymentGroup.totalOther">
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ index + 1 }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ formatDateSignUser(item.date) }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ item.detail }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ item.unit }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ item.quantity }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ formatVND(Number(item.price)) }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2 text-center">
                                                                {{ formatVND(Number(item.money)) }}
                                                            </td>
                                                            <td class="border border-gray-300 p-2">
                                                                {{ item.note }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="text-center mt-4 mb-4">
                                <h2 class="font-bold sm:text-xl text-lg">{{ headerTitle }}</h2>
                            </div>
                            <div>
                                <div>Bên A : (Bên mua)</div>
                                <div>
                                    <div class="overflow-x-auto">
                                        <table class="w-full border-collapse border border-gray-300 text-sm">
                                            <thead>
                                                <tr class="bg-gray-100 text-left">
                                                    <td colspan="2" class="min-w-[300px] w-full border border-gray-300 p-2">
                                                        BỘ PHẬN / PHÒNG BAN</td>
                                                    <td colspan="2" class="min-w-[300px] w-full border border-gray-300 p-2">
                                                        SẢN PHẨM / HÀNG HÓA</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td class="border border-gray-300 p-2">Kính Gửi</td>
                                                    <td class="border border-gray-300 p-2">{{ billdetail.company }}</td>
                                                    <td class="border border-gray-300 p-2">Số CT</td>
                                                    <td class="border border-gray-300 p-2">{{ billdetail.companyNumber }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="border border-gray-300 p-2">Họ và tên</td>
                                                    <td class="border border-gray-300 p-2">{{ billdetail.authuserslog.name
                                                        }}
                                                    </td>
                                                    <td class="border border-gray-300 p-2">Ngày</td>
                                                    <td class="border border-gray-300 p-2">{{
                                                        formatDate(billdetail.createdAt)
                                                        }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="border border-gray-300 p-2">Bộ phận</td>
                                                    <td class="border border-gray-300 p-2">{{ billdetail.departments[0].name }}
                                                    </td>
                                                    <td class="border border-gray-300 p-2">Loại HH</td>
                                                    <td class="border border-gray-300 p-2">{{ billdetail.typeOfGoods }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div>Bên B : (Bên bán)</div>
                                    <div class="overflow-x-auto">
                                        <table class="w-full border-collapse border border-gray-300 text-sm">
                                            <tr>
                                                <td class="border border-gray-300 p-2">Nhà cung cấp
                                                </td>
                                                <td class="border border-gray-300 p-2"></td>
                                                <td class="min-w-[300px] border border-gray-300 p-2"><div v-if="billdetail.supplier">{{
                                                    billdetail.supplier }}</div></td>
                                                <td class="border border-gray-300 p-2"></td>
                                            </tr>
                                            <tr>
                                                <td class="border border-gray-300 p-2">Địa chỉ</td>
                                                <td class="border border-gray-300 p-2"></td>
                                                <td class="border border-gray-300 p-2"> <div v-if="billdetail.supplierAddress">{{ billdetail.supplierAddress }}</div>
                                                </td>
                                                <td class="border border-gray-300 p-2"></td>
                                            </tr>
                                            <tr>
                                                <td class="border border-gray-300 p-2">Hình thức T/T</td>
                                                <td class="border border-gray-300 p-2"></td>
                                                <td class="border border-gray-300 p-2" colspan="2">{{
                                                    checkPaymentMethod(billdetail.paymentMethod).label }}</td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div>Nội dung :</div>
                                    <div class="overflow-x-auto">
                                        <table class="w-full border-collapse border border-gray-300 text-sm">
                                            <thead>
                                                <tr>
                                                    <td class="border border-gray-300 p-2 text-center">
                                                        Stt</td>
                                                    <td class=" min-w-[200px] border border-gray-300 p-2 text-center">
                                                        Ngày Ct</td>
                                                    <td class="min-w-[300px] w-full border border-gray-300 p-2 text-center">
                                                        Diễn giải</td>
                                                    <td class=" min-w-[120px]w-full border border-gray-300 p-2 text-center">
                                                        Tổng thanh toán</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in billdetail.paymentGroup" :key="index">
                                                    <td class="border border-gray-300 p-2 text-center">{{ index + 1 }}</td>
                                                    <td class="border border-gray-300 p-2"> {{ item.date }}</td>
                                                    <td class="border border-gray-300 p-2"> {{ item.detail }}</td>
                                                    <td class="border border-gray-300 p-2"> {{ formatNumber(item.money) }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="3" class="border border-gray-300 p-2">Tổng cộng</td>
                                                    <td class="border border-gray-300 p-2">{{
                                                        formatNumber(getTotalMoney(billdetail.paymentGroup)) }}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="3" class="border border-gray-300 p-2">Tổng tiền thanh toán
                                                    </td>
                                                    <td class="border border-gray-300 p-2">{{
                                                        formatNumber(getTotalMoney(billdetail.paymentGroup)) }}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" class="border border-gray-300 p-2">Bằng Chữ :</td>
                                                    <td colspan="2" class="border border-gray-300 p-2">{{
                                                        formattedAmount(getTotalMoney(billdetail.paymentGroup)) }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="mt-2" v-if="billdetail.paymentMethod === '2'">
                                        <div>Tên tài khoản: <span class="italic">{{ billdetail.accountName }}</span></div>
                                        <div>Số tài khoản: <span class="italic">{{ billdetail.accountNumber }}</span>
                                            <button v-if="billdetail.accountNumber"
                                                @click="copyToClipboard(billdetail.accountNumber)"
                                                class="ml-2 text-xs border-2 rounded-md px-[4px] py-[2px] bg-gray-400 text-white">Sao
                                                chép</button>
                                        </div>
                                        <div>Ngân hàng: <span class="italic">{{ billdetail.bankName }}</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="grid my-6 sm:text-sm text-[10px] text-center sm:p-4 p-2 grid-cols-4 gap-4">
                        <div class="font-bold">CEO</div>
                        <div class="font-bold">GĐ tài chính/Kế toán trưởng</div>
                        <div class="font-bold">Trưởng bộ phận</div>
                        <div class="font-bold">Người đề nghị thanh toán</div>
                        <div class="italic sm:text-xs text-[8px]">(Ký, họ tên)</div>
                        <div class="italic sm:text-xs text-[8px]">(Ký, họ tên)</div>
                        <div class="italic sm:text-xs text-[8px]"
                            >
                            (Ký, họ tên)</div>
                        <div class="italic sm:text-xs text-[8px]">(Ký, họ tên)</div>
                        <div class="h-10 text-[40px] flex items-center justify-center">
                            <font-awesome-icon v-if="reviewer === true" class="h-full m-auto"
                                :icon="['fas', 'circle-check']" style="color: #33e636;" />
                            <button
                                v-else-if="reviewer === false && $app.userInfo.user_role.value === 0 && billdetail.status !== 0"
                                class="sm:text-xs text-[10px] border-2 border-gray-500 p-1 rounded-md sm:w-1/2 w-full"
                                @click="openCheckOTP('reviewer')">ký
                                tên</button>
                            <div v-else class="italic text-gray-500 sm:text-xs text-[10px] ">
                                <p v-if="billdetail.status === 0">( Phiếu đã hủy )</p>
                                <p v-else>( chưa ký )</p>
                            </div>
                        </div>
                        <div class="h-10 text-[40px] flex items-center justify-center">
                            <font-awesome-icon v-if="chiefaccountant === true" class="h-full m-auto"
                                :icon="['fas', 'circle-check']" style="color: #33e636;" />
                            <button
                                v-else-if="chiefaccountant === false && $app.userInfo.user_role.value === 1 && billdetail.status !== 0"
                                class="sm:text-xs text-[10px] border-2 border-gray-500 p-1 rounded-md sm:w-1/2 w-full"
                                @click="openCheckOTP('chiefAccountant')">ký tên</button>
                            <div v-else class="italic text-gray-500 sm:text-xs text-[10px] ">
                                <p v-if="billdetail.status === 0">( Phiếu đã hủy )</p>
                                <p v-else>( chưa ký )</p>
                            </div>
                        </div>
                        <div
                            class="h-10 text-[40px] flex items-center justify-center">
                            <font-awesome-icon v-if="departmentmanager === true" class="h-full m-auto"
                                :icon="['fas', 'circle-check']" style="color: #33e636;" />
                            <button
                                v-else-if="departmentmanager === false && $app.userInfo.user_role.value === 2 && billdetail.status !== 0"
                                class="sm:text-xs text-[10px] border-2 border-gray-500 p-1 rounded-md sm:w-1/2 w-full"
                                @click="openCheckOTP('departmentManager')">ký tên</button>
                            <div v-else class="italic text-gray-500 sm:text-xs text-[10px]">
                                <p v-if="billdetail.status === 0">( Phiếu đã hủy )</p>
                                <p v-else>( chưa ký )</p>
                            </div>
                        </div>
                        <div class="h-10 text-[40px] flex items-center justify-center">
    
                            <font-awesome-icon v-if="requestingpayment === true" class="h-full m-auto"
                                :icon="['fas', 'circle-check']" style="color: #33e636;" />
                            <button
                                v-else-if="requestingpayment === false && $app.userInfo.user_role.value === 3 && billdetail.status !== 0"
                                class="sm:text-xs text-[10px] border-2 border-gray-500 p-1 rounded-md sm:w-1/2 w-full"
                                @click="openCheckOTP('requestingPayment')">ký tên</button>
                            <div v-else class="italic text-gray-500 sm:text-xs text-[10px] ">
                                <p v-if="billdetail.status === 0">( Phiếu đã hủy )</p>
                                <p v-else>( chưa ký )</p>
                            </div>
                        </div>
                        <div class="text-xs">
                            <p v-if="reviewer !== false">Ngày ký: {{ reviewerDate }}</p>
                        </div>
                        <div class="text-xs">
                            <p v-if="chiefaccountant !== false">Ngày ký: {{ chiefaccountantDate }}</p>
                        </div>
                        <div
                            class="text-xs">
                            <p v-if="departmentmanager !== false">Ngày ký: {{
                                departmentmanagerDate }}</p>
                        </div>
                        <div class="text-xs">
                            <p v-if="requestingpayment !== false">Ngày ký: {{ requestingpaymentDate }}</p>
                        </div>
                        <div class="font-bold">{{ reviewerName }}</div>
                        <div class="font-bold">{{ chiefaccountantName }}</div>
                        <div
                            class="font-bold">{{ departmentmanagerName }}</div>
                        <div class="font-bold">{{ requestingpaymentName }}</div>
                    </div>
                </div>
                <div class="p-6 max-w-3xl ">
                    <div class="italic underline text-[14px] font-bold">File đính kèm:</div>
                    <ul v-if="billdetail.attachedfile.length === 0" class="mt-1 mb-1 text-gray-400 italic text-[16px]">Không
                        có file đính kèm nào !!</ul>
                    <ul class="flex flex-wrap mt-3 gap-3">
                        <li v-for="(file, index) in billdetail.attachedfile" :key="index"
                            class="relative flex flex-col items-center bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md hover:border-brand/40 transition-all p-4 w-[130px] cursor-pointer group"
                            @click="previewFile(file)">
                            <!-- Hình đại diện theo loại file -->
                            <div class="w-14 h-14 flex items-center justify-center bg-gray-50 rounded-full shadow-inner group-hover:scale-105 transition-transform border border-gray-100">
                                <img v-if="isImage(file)" src="../../assets/png-file.png" alt="IMG Icon" class="w-8 h-8 object-contain drop-shadow-sm" />
                                <img v-else-if="isPDF(file)" src="../../assets/pdf-file.png" alt="PDF Icon" class="w-8 h-8 object-contain drop-shadow-sm" />
                                <img v-else-if="isDoc(file)" src="../../assets/doc-file.png" alt="DOC Icon" class="w-8 h-8 object-contain drop-shadow-sm" />
                                <img v-else-if="isExcel(file)" src="../../assets/exe-file.png" alt="DOC Icon" class="w-8 h-8 object-contain drop-shadow-sm" />
                                <img v-else :src="file.url" alt="File Icon" class="w-8 h-8 object-contain drop-shadow-sm" />
                            </div>
                            <p class="mt-3 text-center text-[13px] font-semibold text-gray-700 truncate w-full" :title="file.name">{{ file.name }}</p>
                        </li>
                    </ul>
    
                    <!-- Modal xem trước file -->
                </div>
            </template>
            <template slot="footer" v-if="isConfigValidBill === false && ($app.userInfo.user_role.value === 1 || ($app.userInfo.user_role.value === 3 && $app.userInfo.departments?.some(el => el.value === 3)))">
                <div class="w-full flex items-center justify-between px-4 py-2 bg-white/95 backdrop-blur-md md:rounded-b-2xl shadow-[0_-4px_10px_rgba(0,0,0,0.02)] mt-auto">
                    <div class="flex items-center gap-2">
                        <el-checkbox v-model="localIsValid" class="font-semibold text-[13px]" :class="localIsValid ? 'text-green-600' : 'text-gray-700'">
                            ĐÃ KIỂM TRA
                        </el-checkbox>
                    </div>

                    <div class="flex items-center gap-3">
                        <button v-if="isUpdatingValid" disabled
                            class="min-w-[120px] py-1.5 px-4 text-[13px] text-white font-bold rounded-lg bg-gray-400 cursor-not-allowed flex items-center justify-center shadow-sm transition-all">
                            <p class="flex items-center gap-2">
                                <font-awesome-icon :icon="['fas', 'spinner']" class="fa-spin" /> Đang lưu
                            </p>
                        </button>
                        <button v-else
                            class="min-w-[120px] py-1.5 px-4 text-[13px] bg-brand text-white font-bold rounded-lg shadow-[0_4px_10px_rgba(2,75,179,0.3)] hover:-translate-y-[1px] hover:bg-brand-light hover:shadow-[0_6px_14px_rgba(2,75,179,0.4)] transition-all flex justify-center items-center gap-2"
                            @click="updateValidStatus">
                            <font-awesome-icon :icon="['fas', 'check-double']" />
                            <p>Lưu cập nhật</p>
                        </button>
                    </div>
                </div>
            </template>
        </Popup>
        <Check2FA v-if="isShowCheck2FAPopup" :isShow="isShowCheck2FAPopup" @closed="isShowCheck2FAPopup = false"
                :billdetail="billdetail" :optionpropvalue="optionpropvalue" @update="updateReviewer" />
        <ViewAttachedFile 
            v-for="(popup, index) in openPopups"
            v-if="popup.isShowPopup" 
            :key="'AttachedFile' + popup.id"
            :isShow="popup.isShowPopup"
            @closed="onClosedAttachedFilePopup(popup.id)" 
            :selectedFile="popup" 
            />
    </div>
</template>

<script>
import Popup from '../component/common/Popup.vue';
import Check2FA from './Check2FA.vue';
import moment from 'moment'
import ViewAttachedFile from './ViewAttachedFile.vue';
import { formatNumber } from '@/utils/onlyNum';

const IMG_URL = process.env.VUE_APP_IMG_URL
const API_URL = process.env.VUE_APP_API_URL
export default {
    components: {
        Check2FA,
        ViewAttachedFile,
        Popup
    },
    props: {
        isShow: {
            type: Boolean,
            default: false,
        },
        billdetail: {
            type: Object,
            default: null
        },
        isUpdateValidMode: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            urlApi: IMG_URL,
            isShowCheck2FAPopup: false,
            isVisible: true,
            selectedOptionPayment: '2',
            reviewer: false,
            reviewerName: '',
            reviewerDate: '',

            chiefaccountant: false,
            chiefaccountantName: '',
            chiefaccountantDate: '',

            departmentmanager: false,
            departmentmanagerName: '',
            departmentmanagerDate: '',

            requestingpayment: false,
            requestingpaymentName: '',
            requestingpaymentDate: '',
            optionpropvalue: '',

            showFile: false,
            isLoading: false,

            isShowViewAttachedFilePopup: false,
            selectedFile: null,
            currentIndex: 0,
            isShowPopup: false,
            localIsValid: false,
            isUpdatingValid: false,
            openPopups: [],
            isConfigValidBill: false
        };
    },
    computed: {
        headerTitle() {
            const type = this.$app.billTypes.find(item => item.value === this.billdetail.billType)
            return type ? type.label.toUpperCase() : ''
        },
        totalAllMoney() {
            return [
                ...(this.billdetail.paymentGroup.totalInventoryMaterials || []),
                ...(this.billdetail.paymentGroup.totalCeremonyMaterials || []),
                ...(this.billdetail.paymentGroup.totalNonInventoryMaterials || []),
                ...(this.billdetail.paymentGroup.totalOther || [])
            ].reduce((sum, item) => sum + (Number(item.money) || 0), 0)
        },
    },
    mounted() {
        if(this.isShow) {
            this.isShowPopup = true
            document.body.style.overflow = 'hidden'
        }
        this.fetchConfig();
    },
    beforeDestroy() {
        document.body.style.overflow = ''
    },
    watch: {
        billdetail: {
            handler(newVal) {
                if (newVal) {
                    if (newVal.reviewer !== null) {
                        this.reviewer = newVal.reviewer.sign;
                        this.reviewerName = newVal.reviewer.name
                        this.reviewerDate = newVal.reviewer.date

                    }
                    if (newVal.chiefAccountant !== null) {
                        this.chiefaccountant = newVal.chiefAccountant.sign;
                        this.chiefaccountantName = newVal.chiefAccountant.name
                        this.chiefaccountantDate = newVal.chiefAccountant.date

                    }
                    if (newVal.departmentManager !== null) {
                        this.departmentmanager = newVal.departmentManager.sign;
                        this.departmentmanagerName = newVal.departmentManager.name
                        this.departmentmanagerDate = newVal.departmentManager.date

                    }
                    if (newVal.requestingPayment !== null) {
                        this.requestingpayment = newVal.requestingPayment.sign;
                        this.requestingpaymentName = newVal.requestingPayment.name
                        this.requestingpaymentDate = newVal.requestingPayment.date
                    }
                    this.localIsValid = !!newVal.isValid;
                }
            },
            deep: true, // Lắng nghe thay đổi sâu bên trong object
            immediate: true // Chạy ngay lần đầu tiên khi component được mount
        }
    },
    methods: {
        async fetchConfig() {
            try {
                const res = await this.$axios.get(`${API_URL}/bills/config`, {
                    headers: { 'X-Authorization': `Bearer ${this.$app.token}` }
                });
                if (res.data && res.data.success) {
                    this.isConfigValidBill = res.data.filterValidBill;
                }
            } catch (err) {
                console.error("Lỗi lấy config Bills:", err);
            }
        },
        formatNumber,
        heckNegative(value) {
            return value < 0 ? 0 : value
        },
        checkPaymentMethod(e) {
            switch (e) {
                case '1':
                    return {
                        label: 'Tiền mặt'
                    }
                case '2':
                    return {
                        label: 'Ngân hàng'
                    }
            }
        },
        getTotalMoney(arr) {
            return arr.reduce((sum, item) => {
                return sum + (Number(item.money) || 0);
            }, 0);
        },
        openAttachedFilePopup(file) {
            const exist = this.openPopups.find(p => p.id === file.id)
            if (!exist) {
                this.openPopups.push({
                ...file,
                isShowPopup: true,
                })
            }
        },
        onClosedAttachedFilePopup(id) {
            this.openPopups = this.openPopups.filter(p => p.id !== id)
        },
        closedPopup() {
            this.isShowPopup = false
            setTimeout(() => {
                this.$emit('closed', this.isLoading);
            }, 200);
        },
        async updateValidStatus() {
            this.isUpdatingValid = true;
            try {
                // Sử dụng API batchUpdateValid cho 1 ids
                const res = await this.$axios.post(`${API_URL}/bills/batchUpdateValid`, {
                    ids: [this.billdetail.id],
                    isValid: this.localIsValid
                }, {
                    headers: { 'X-Authorization': `Bearer ${this.$app.token}` }
                });
                if (res.data.success) {
                    this.$notify.success({ title: 'Thành công', message: 'Cập nhật trạng thái Đã kiểm tra thành công!' });
                    this.billdetail.isValid = this.localIsValid; 
                    this.$emit('reload');
                    this.closedPopup();
                }
            } catch (error) {
                console.error(error);
                this.$notify.error({ title: 'Lỗi', message: 'Cập nhật thất bại' });
            } finally {
                this.isUpdatingValid = false;
            }
        },
        changePage(index) {
            this.currentIndex = index
            this.$nextTick(() => {
                // reset scroll cho từng trang
                if (index === 0 && this.$refs.page1) this.$refs.scrollWrapper.scrollTop = 0
                if (index === 1 && this.$refs.page2) this.$refs.scrollWrapper.scrollTop = 0
            })
        },
        isImage(file) {
            return file && file.mime && file.mime.startsWith("image/");
        },
        isPDF(file) {
            return file && file.mime === "application/pdf";
        },
        isDoc(file) {
            return file && (file.mime === "application/msword" || file.mime === "application/vnd.openxmlformats-officedocument.wordprocessingml.document");
        },
        isExcel(file) {
            return file && file.mime === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        },
        previewFile(file) {
            this.selectedFile = file;
            setTimeout(() => {
                this.isShowViewAttachedFilePopup = true
                this.openAttachedFilePopup(file)
            }, 200);
        },
        checkformBill(e) {
            if (Number(e) === 8 && this.billdetail?.otherFormOfBill) {
                return { label: this.billdetail.otherFormOfBill };
            }
            switch (Number(e)) {
                case 1:
                    return { label: 'Cửa hàng' }
                case 2:
                    return { label: 'Văn phòng' }
                case 3:
                    return { label: 'Phiếu bếp' }
                case 4:
                    return { label: 'Phiếu nhà cung cấp' }
                case 5:
                    return { label: 'Nhà máy IQF' }
                case 6:
                    return { label: 'Thương mại' }
                case 7:
                    return { label: 'Chi phí farm' }
                case 8:
                    return { label: this.billdetail?.otherFormOfBill || 'Khác' }
                default:
                    return { label: 'Không xác định' }
            }
        },
        formatDateSignUser(e) {
            return moment(e).format('DD/MM/YYYY')
        },
        // openLocalFile(data) {
        //     this.listFiles = data
        //     setTimeout(() => {
        //         this.isShowAttachedFilePopup = true
        //     }, 200);
        // },
        openCheckOTP(option) {
            this.optionpropvalue = option
            this.isShowCheck2FAPopup = true
        },
        closePopup() {
            this.isVisible = false
            setTimeout(() => {
                this.$emit('closed', this.isLoading);
            }, 200);
        },
        noAcces() {
            alert('Bạn không có quyền xử dụng tính năng này')
        },
        formatVND(amount) {
            return amount.toLocaleString("vi-VN", { style: "currency", currency: "VND" });
        },
        formattedAmount(n) {
            if (n) {
                const units = ["", "mươi", "trăm"];
                const bigUnits = ["", "nghìn", "triệu", "tỷ", "nghìn tỷ", "triệu tỷ"];
                const digits = ["không", "một", "hai", "ba", "bốn", "năm", "sáu", "bảy", "tám", "chín"];

                function readThreeDigits(num) {
                    let str = "";
                    let hundred = Math.floor(num / 100);
                    let ten = Math.floor((num % 100) / 10);
                    let unit = num % 10;

                    if (hundred > 0) {
                        str += digits[hundred] + " trăm ";
                        if (ten === 0 && unit > 0) str += "lẻ ";
                    }
                    if (ten > 1) {
                        str += digits[ten] + " mươi ";
                        if (unit === 1) str += "mốt ";
                        else if (unit === 5) str += "lăm ";
                        else if (unit > 0) str += digits[unit] + " ";
                    } else if (ten === 1) {
                        str += "mười ";
                        if (unit === 5) str += "lăm ";
                        else if (unit > 0) str += digits[unit] + " ";
                    } else if (unit > 0) {
                        str += digits[unit] + " ";
                    }

                    return str.trim();
                }

                function splitNumberToParts(num) {
                    let parts = [];
                    while (num > 0) {
                        parts.push(num % 1000);
                        num = Math.floor(num / 1000);
                    }
                    return parts;
                }

                let num = parseInt(n.toString().replace(/\D/g, ""), 10);
                if (isNaN(num) || num === 0) return "không đồng";

                let parts = splitNumberToParts(num);
                let result = "";

                for (let i = parts.length - 1; i >= 0; i--) {
                    if (parts[i] > 0) {
                        result += readThreeDigits(parts[i]) + " " + bigUnits[i] + " ";
                    }
                }

                return result.trim() + " đồng";
            }

        },
        formatDate(data) {
            const date = new Date(data);
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0"); // Thêm 0 nếu cần
            const year = date.getFullYear();
            const formattedDate = `Ngày ${day} tháng ${month} năm ${year}`;
            return formattedDate
        },
        async updateReviewer(data, role) {
            this.isShowCheck2FAPopup = false;
            const id = data.id;

            const dataupdate = {
                name: this.$app.userInfo.name,
                date: new Date().toLocaleString('vi-VN', {
                    timeZone: 'Asia/Ho_Chi_Minh',
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                }),
                sign: true
            };

            await this.$axios.put(`${API_URL}/bills/update/${id}`, {
                type: role,         // Gửi loại cập nhật
                data: dataupdate    // Gửi dữ liệu cập nhật
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Authorization': `Bearer ${this.$app.token}`,
                },
            }).then(res => {
                if (res.status === 200) {
                    this.isLoading = true;
                    const bill = res.data.bill;

                    if (bill.reviewer) {
                        this.reviewer = bill.reviewer.sign;
                        this.reviewerName = bill.reviewer.name;
                        this.reviewerDate = bill.reviewer.date;
                    }
                    if (bill.chiefAccountant) {
                        this.chiefaccountant = bill.chiefAccountant.sign;
                        this.chiefaccountantName = bill.chiefAccountant.name;
                        this.chiefaccountantDate = bill.chiefAccountant.date;
                    }
                    if (bill.departmentManager) {
                        this.departmentmanager = bill.departmentManager.sign;
                        this.departmentmanagerName = bill.departmentManager.name;
                        this.departmentmanagerDate = bill.departmentManager.date;
                    }
                    if (bill.requestingPayment) {
                        this.requestingpayment = bill.requestingPayment.sign;
                        this.requestingpaymentName = bill.requestingPayment.name;
                        this.requestingpaymentDate = bill.requestingPayment.date;
                    }

                    if (bill.reviewer && bill.status !== 0) {
                        setTimeout(() => {
                            this.updateStatus(id);
                        }, 200);
                    }
                    
                    const isAccountant = this.$app.userInfo.user_role.value === 1 || (this.$app.userInfo.user_role.value === 3 && this.$app.userInfo.departments?.some(el => el.value === 3));
                    if (!isAccountant) {
                        this.closePopup();
                    }
                    
                    this.$emit('reload')
                }
            }).catch(err => {
                console.log(err);
                this.$notify.error({
                    title: 'Thất bại',
                    message: 'Xảy ra lỗi khi cập nhật trạng thái.'
                });
            });
        },
        async updateStatus(id) {
            await this.$axios.put(`${API_URL}/bills/update/${id}`, {
                type: 'status',
                data: 2
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Authorization': `Bearer ${this.$app.token}`,
                },
            }).then(res => {
                this.$emit('reload');
            }).catch(err => {
                console.log(err);
                this.$notify.error({
                    title: 'Thất bại',
                    message: 'Xảy ra lỗi khi cập nhật trạng thái.'
                });
            });
        },

        copyToClipboard(value) {
            navigator.clipboard.writeText(value).then(() => {
                this.$notify.success({
                    title: 'Thành công',
                    message: 'Sao chép thành công.'
                });
            })
                .catch((err) => console.error("Lỗi sao chép: ", err));
        },
        print() {
            const printArea = this.$refs.printArea;
            if (!printArea) return;

            const printContents = printArea.innerHTML;
            const printWindow = window.open('', '_blank', 'width=900,height=750');
            if (!printWindow) {
                this.$notify.error({ title: 'Thất bại', message: 'Trình duyệt đang chặn cửa sổ in. Vui lòng cho phép mở popup để in phiếu.' });
                return;
            }

            const voucherTitle = this.headerTitle || 'Phiếu Chi';
            const code = this.billdetail?.code || '';

            printWindow.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <meta charset="utf-8">
                    <title>${voucherTitle} - ${code}</title>
                    <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
                    <style>
                        @media print {
                            @page {
                                size: A4 portrait;
                                margin: 12mm 10mm 12mm 10mm;
                            }
                            body {
                                margin: 0;
                                padding: 0;
                                background: #ffffff !important;
                                color: #000000 !important;
                                font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
                                -webkit-print-color-adjust: exact !important;
                                print-color-adjust: exact !important;
                            }
                            .no-print, button, .no-print-area {
                                display: none !important;
                            }
                        }
                        body {
                            padding: 20px;
                            background: #ffffff;
                            font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                        }
                        img {
                            max-width: 100%;
                            height: auto;
                        }
                    </style>
                </head>
                <body>
                    <div class="print-wrapper">
                        ${printContents}
                    </div>
                </body>
                </html>
            `);

            printWindow.document.close();
            printWindow.focus();

            setTimeout(() => {
                printWindow.print();
                printWindow.onafterprint = () => {
                    printWindow.close();
                };
            }, 300);
        },

        async exportExcel(id) {
            const data = { selectedIds: [id] };

            try {
                const res = await this.$axios.post(
                    `${API_URL}/bills/export`,
                    data,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Authorization': `Bearer ${this.$app.token}`,
                        },
                    }
                );

                // ✅ Kiểm tra nếu backend trả về dạng { files: [...] }
                if (res.data && Array.isArray(res.data.files)) {
                    res.data.files.forEach(file => {
                        // Giải mã base64 sang Blob
                        const byteCharacters = atob(file.data);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const blob = new Blob([new Uint8Array(byteNumbers)], {
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        });

                        // Tạo link tải từng file
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', file.name || 'file.xlsx');
                        document.body.appendChild(link);
                        link.click();

                        // Dọn dẹp
                        window.URL.revokeObjectURL(url);
                        link.remove();
                    });
                } else {
                    // ✅ Trường hợp chỉ có 1 file (dạng blob)
                    const blob = new Blob([res.data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'PHIẾU THANH TOÁN TẠM ỨNG.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    window.URL.revokeObjectURL(url);
                    link.remove();
                }

            } catch (err) {
                console.error("Lỗi khi xuất Excel:", err);
                this.$notify.error({
                    title: 'Lỗi xuất Excel',
                    message: err.message || 'Đã có lỗi xảy ra khi xuất file Excel.'
                });
            }
        }


    },

};
</script>

<style scoped>
.no-scrollbar::-webkit-scrollbar {
    display: none;
    /* Ẩn trên Chrome, Safari */
}

.no-scrollbar {
    -ms-overflow-style: none;
    /* Ẩn trên IE, Edge */
    scrollbar-width: none;
    /* Ẩn trên Firefox */
}

@keyframes popupFadeIn {
    0% {
        opacity: 0;
        transform: translateY(10px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes popupFadeOut {
    0% {
        opacity: 1;
        transform: translateY(0);
    }

    100% {
        opacity: 0;
        transform: translateY(10px);
    }
}

.animate-popupFadeIn {
    animation: popupFadeIn 0.5s forwards;
}

.animate-popupFadeOut {
    animation: popupFadeOut 0.5s forwards;
}
</style>